/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { WhenSignedIn, WhenSignedOut } from 'mydnv/components/sign-in/sign_in_out_util';
import { FollowedInfoCard } from 'components/page-title/followed-infocard/followed-infocard';
import { Config } from 'config';

const LoginSignupButtonsComponent = () => {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const SignInRequest = Config.MyDNV.loginRequest;
    const SignUpRequest = Config.MyDNV.signUpRequest;

    const login = (request) => {
        if (!isAuthenticated && inProgress === InteractionStatus.None) {
            instance.loginRedirect(request).catch((e) => {
                console.log(e);
            });
        }
    };

    return (
        <>
            <WhenSignedOut>
                <div className='button-wrapper'>
                    <button className='btn' onClick={() => login(SignUpRequest)}>
                        Sign up
                    </button>
                    or
                    <button className='btn outline' onClick={() => login(SignInRequest)}>
                        Log in
                    </button>
                </div>
            </WhenSignedOut>

            <WhenSignedIn>
                <FollowedInfoCard type='logged-in' />
            </WhenSignedIn>
        </>
    );
};

LoginSignupButtonsComponent.displayName = 'LoginSignupButtonsComponent';
export { LoginSignupButtonsComponent };
